import { useAtomValue } from 'jotai';

import { AccessoriesListView } from '@common/components/AccessoriesListView';
import { AccordionSection } from '@common/components/AccordionSection';

import { useGetOrderDetails } from '../../api/useGetOrderDetails';
import { orderDetailsDrawerAtom } from '../../atoms/orderDetailsDrawerAtoms';

import { SectionSkeleton } from './shared/SectionSkeleton';

const SECTION_TITLE = 'PG&A';

interface PartsGarmentsAndAccessoriesContentProps {
	purchasedVehicleId: string;
}

export const PartsGarmentsAndAccessoriesContent = ({
	purchasedVehicleId,
}: PartsGarmentsAndAccessoriesContentProps) => {
	const { data: orderDetails } = useGetOrderDetails(purchasedVehicleId);

	if (!orderDetails) {
		return null;
	}

	const { partsGarmentsAndAccessories } = orderDetails;

	return (
		<AccessoriesListView
			accessories={partsGarmentsAndAccessories}
			title=''
			emptyMessage='No accessories on this order'
		/>
	);
};

export const PartsGarmentsAndAccessoriesSection = () => {
	const { selectedRow } = useAtomValue(orderDetailsDrawerAtom);
	const { data: orderDetails, isLoading } = useGetOrderDetails(
		selectedRow?.purchasedVehicleId || undefined,
	);

	if (isLoading) {
		return <SectionSkeleton title={SECTION_TITLE} />;
	}

	if (!orderDetails || !selectedRow?.purchasedVehicleId) {
		return null;
	}

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<PartsGarmentsAndAccessoriesContent
				purchasedVehicleId={selectedRow.purchasedVehicleId}
			/>
		</AccordionSection>
	);
};
